/**
 * Created by jv on 16/03/2017.
 */
const utils = require("Sources/utils/utils");

const knownErrors = [ "E95382",
                      "E45370",
                      "E15688",
                      "E79658",
                      "E94337",
                      "E35077",
                      "E76947",
                      "E12319",
                      "E55862",
                      "E55862",
                      "E12159",
                      "E97135",
                      "E85246",
                      "E97581",
                      "E98334",
                      "E98712",
                      "E91684",
                      "E78654",
                      "E64825",
                      "E97316",
                      "E39824",
                      "E78924",
                      "E97357",
                      "E65591",
                      "E99761",
                      "E54652",
                      "E25748",
                      "E23515",
                      "E76378",
                      "E37392",
                      "E14125",
                      "E12796",
                      "E61269",
                      "E87805",
                      "E78220",
                      "E69920",
                      "E77753",
                      "E89251",
                      "E98264",
                      "E65824",
                      "E35712",
                      "E55322",
                      "E26024",
                      "E53496",
                      "E85936",
                      "E22663",
                      "E73541",
                      "E96293",
                      "E38630"];

module.exports = class Error
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.code = options.code;
    this.message = options.message;
  }

  get readableErrorTitle()
  {
    if($.inArray(this.code, knownErrors) !== -1)
    {
      return "errors.services." + this.code + ".title";
    }

    return "errors.services.general.title";
  }

  get readableErrorMessage()
  {
    if($.inArray(this.code, knownErrors) !== -1)
    {
      return "errors.services." + this.code + ".message";
    }

    return "errors.services.general.message";
  }
}



// WEBPACK FOOTER //
// ./app/js/models/error.js